/* SnapTint one-box vehicle finder. Data: assets/st-vehicles.json (scripts/shopify/build_vehicle_asset.py):
   { m: [makes], v: [[makeIdx, model, handle, kit_size, from, to]] }. Markup: snippets/st-ymm-form.liquid.
   Ported from prototypes/finder-typeahead.template.html ("One search box", approved by Harrison 2026-09-29):
   - every typed word must match the start of a word in the make or model, any order; punctuation/spaces ignored (f150 = F-150);
     nicknames chevy, vw, benz/merc/mb, caddy, olds;
   - a 4-digit year anywhere filters to vehicles made that year and picking a result finishes; a partial year ("model y 20")
     narrows by year prefix only when those digits match no model name ("chrysler 300" still works);
   - no year typed: picking a vehicle switches the list to its years ("18" picks 2018); one-year vehicles finish right away;
   - "328i", "335xi", "535d" also match BMW's listed "328", "335", "535";
   - no vehicle has every word: a 5+ letter word one letter off a make/model word is corrected ("outbavk" -> outback, "curze" ->
     cruze) with "Showing results for …"; failing that, the word that doesn't fit is dropped, with a note;
   - ARIA combobox/listbox: arrows move, Enter picks (or opens the kit page once complete), Escape closes.
   Sends the customer to /pages/car-tint-kits/{handle}?year={year}. */
(function () {
  var ALIAS = { chevy: 'chevrolet', chev: 'chevrolet', vw: 'volkswagen', benz: 'mercedes', merc: 'mercedes', mb: 'mercedes',
    landrover: 'land rover', rangerover: 'land rover', caddy: 'cadillac', olds: 'oldsmobile' };
  var norm = function (s) { return s.toLowerCase().replace(/[^a-z0-9 ]+/g, '').replace(/\s+/g, ' ').trim(); };
  var squash = function (s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, ''); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var yrs = function (v) { return v.from ? (v.from === v.to ? String(v.from) : v.from + '–' + v.to) : 'ask us'; };
  var nameOf = function (v) { return v.make + ' ' + v.model; };
  var loads = {};

  function load(src) {
    if (!loads[src]) loads[src] = fetch(src).then(function (r) { return r.json(); }).then(function (d) {
      return d.v.map(function (x) {
        var make = d.m[x[0]], words = norm(make + ' ' + x[1]).split(' ');
        return { make: make, model: x[1], handle: x[2], from: x[4], to: x[5], words: words, sq: words.map(squash) };
      });
    });
    return loads[src];
  }

  var vocabs = typeof WeakMap === 'function' ? new WeakMap() : null;
  function vocabOf(V) {                        // distinct make/model words (letters only, 4+), for typo correction
    var got = vocabs && vocabs.get(V);
    if (got) return got;
    var seen = {}, list = [];
    V.forEach(function (v) { v.words.forEach(function (w) { var q = squash(w); if (q.length >= 4 && !/\d/.test(q) && !seen[q]) { seen[q] = 1; list.push({ word: w, sq: q }); } }); });
    if (vocabs) vocabs.set(V, list);
    return list;
  }
  function oneOff(a, b) {                      // true if a and b differ by one substitution, insertion, deletion or adjacent swap
    if (a === b) return false;
    var la = a.length, lb = b.length, i = 0;
    if (Math.abs(la - lb) > 1) return false;
    while (i < la && i < lb && a[i] === b[i]) i++;
    if (la === lb) return a.slice(i + 1) === b.slice(i + 1) || (a[i] === b[i + 1] && a[i + 1] === b[i] && a.slice(i + 2) === b.slice(i + 2));
    return la > lb ? a.slice(i + 1) === b.slice(i) : a.slice(i) === b.slice(i + 1);
  }
  function parse(q) {
    var year = null;
    var toks = norm(q).split(' ').filter(Boolean).filter(function (t) {
      if (/^(19[6-9]\d|20[0-3]\d)$/.test(t)) { year = +t; return false; }
      return true;
    }).map(function (t) { return ALIAS[t] || t; });
    return { year: year, toks: [].concat.apply([], toks.map(function (t) { return t.split(' '); })) };
  }
  function tokHits(v, t) {
    var s = squash(t);
    if (!s) return true;
    var bmw = s.match(/^(\d{3})(xi|ci|is|i|d|e)x?$/);                       // "328i", "335xi", "535d": listed as "328 4 Door"
    if (bmw && tokHits(v, bmw[1])) return true;
    // a token matches the start of a word, or runs across adjacent words ("f150" vs "f 150", "rav4" vs "rav 4")
    for (var i = 0; i < v.sq.length; i++) {
      var joined = '';
      for (var j = i; j < v.sq.length; j++) { joined += v.sq[j]; if (joined.indexOf(s) === 0) return true; if (joined.length >= s.length) break; }
    }
    return false;
  }
  function search(V, q, preMake) {
    var p = parse(q), year = p.year, toks = p.toks;
    var every = function (list) { return function (v) { return list.every(function (t) { return tokHits(v, t); }); }; };
    var hits = V.filter(every(toks));
    var part = toks.filter(function (t) { return /^(19|19\d|20|20\d)$/.test(t); });
    if (!hits.length && part.length) {
      // "model y 20", "civic 201": digits that match no model are the start of a year
      toks = toks.filter(function (t) { return part.indexOf(t) < 0; });
      var covers = function (v) {
        return v.from && part.every(function (pp) { for (var y = v.from; y <= v.to; y++) if (String(y).indexOf(pp) === 0) return true; return false; });
      };
      hits = V.filter(function (v) { return every(toks)(v) && covers(v); });
    }
    var skipped = [], fixed = null;
    if (!hits.length) {
      // "subaru outbavk", "chevrolet curze": a word of 5+ letters that matches nothing may be one letter off (wrong, missing,
      // extra or swapped) from a make/model word; try those corrections before dropping a word
      var vocab = vocabOf(V), tries = toks.map(function (t) {
        var st = squash(t);
        if (st.length < 5 || /\d/.test(st) || V.some(function (v) { return tokHits(v, t); })) return [t];
        return [t].concat(vocab.filter(function (w) { return oneOff(st, w.sq) || (w.sq.length > st.length && oneOff(st, w.sq.slice(0, st.length))); })
          .map(function (w) { return w.word; }));
      });
      var combos = [[]];
      tries.forEach(function (alts) { var next = []; combos.forEach(function (c) { alts.slice(0, 6).forEach(function (a) { next.push(c.concat([a])); }); }); combos = next.slice(0, 60); });
      for (var ci = 1; ci < combos.length && !hits.length; ci++) {
        var h2 = V.filter(every(combos[ci]));
        if (year) h2 = h2.filter(function (v) { return v.from && v.from <= year && year <= v.to; });
        if (h2.length) { hits = h2; toks = combos[ci]; fixed = combos[ci].join(' '); }
      }
    }
    var inYear = function (list) { return year ? list.filter(function (v) { return v.from && v.from <= year && year <= v.to; }) : list; };
    if (!hits.length && toks.length > 1) {
      // two words that are one in our list ("land cruiser" -> Landcruiser): join neighbours and try again
      for (var jn = 0; jn < toks.length - 1 && !hits.length; jn++) {
        if (/\d/.test(toks[jn] + toks[jn + 1])) continue;       // letters only: "e 350" stays the E Class family
        var joinedToks = toks.slice(0, jn).concat([toks[jn] + toks[jn + 1]], toks.slice(jn + 2)), hj = inYear(V.filter(every(joinedToks)));
        if (hj.length) { hits = hj; toks = joinedToks; fixed = joinedToks.join(' '); }
      }
    }
    if (!hits.length && toks.length > 1) {
      // no vehicle has every word: drop the one word that makes it work ("acu civic" -> civic); shortest word first
      var order = toks.slice().sort(function (a, b) { return a.length - b.length; });
      for (var k = 0; k < order.length; k++) {
        var keep = toks.filter(function (x) { return x !== order[k]; }), h = V.filter(every(keep));
        if (h.length) { skipped = [order[k]]; toks = keep; hits = h; break; }
      }
      // still nothing with the year: drop two words, for trims like "super duty" ("f550 super duty") (2026-10-27)
      if (!inYear(hits).length && toks.length > 2) {
        var base = skipped.length ? toks.concat(skipped) : toks;
        // drop trim words first: never a model number (has a digit) or the make; shortest first
        var makes = {}; V.forEach(function (v) { makes[squash(v.make)] = 1; });
        var ord2 = base.filter(function (t) { return !/\d/.test(t) && !makes[squash(t)]; }).sort(function (a, b) { return a.length - b.length; });
        for (var a2 = 0; a2 < ord2.length && !inYear(hits).length; a2++) {
          for (var b2 = a2 + 1; b2 < ord2.length; b2++) {
            var keep2 = base.filter(function (x) { return x !== ord2[a2] && x !== ord2[b2]; });
            if (!keep2.length) continue;
            var h3 = inYear(V.filter(every(keep2)));
            if (h3.length) { skipped = [ord2[a2], ord2[b2]]; toks = keep2; hits = h3; break; }
          }
        }
      }
    }
    if (year) hits = hits.filter(function (v) { return v.from && v.from <= year && year <= v.to; });
    var first = toks[0] ? squash(toks[0]) : '';
    hits.sort(function (a, b) {
      var ap = a.make === preMake ? 0 : 1, bp = b.make === preMake ? 0 : 1;
      var am = squash(a.model).indexOf(first) === 0 ? 0 : 1, bm = squash(b.model).indexOf(first) === 0 ? 0 : 1;
      return ap - bp || am - bm || a.make.localeCompare(b.make) || a.model.localeCompare(b.model);
    });
    return { hits: hits.slice(0, 60), total: hits.length, year: year, toks: toks, skipped: skipped, fixed: fixed };
  }
  function highlight(text, toks) {
    var ts = toks.map(squash);
    return text.split(/(\s+)/).map(function (w) {
      var sw = squash(w);
      var t = sw && ts.filter(function (t) { return t && (sw.indexOf(t) === 0 || t.indexOf(sw) === 0); })[0];
      if (!t) return esc(w);
      var n = Math.min(t.length, sw.length), k = 0, cut = 0;   // cut = characters of w covering n letters/digits
      while (cut < w.length && k < n) { if (/[a-z0-9]/i.test(w[cut])) k++; cut++; }
      return '<mark>' + esc(w.slice(0, cut)) + '</mark>' + esc(w.slice(cut));
    }).join('');
  }

  function combobox(input, list, cfg) {
    var opts = [], active = -1;
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function setActive(i) {
      active = i;
      list.querySelectorAll('[role=option]').forEach(function (li, k) { li.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      var li = document.getElementById(list.id + '-o' + i);
      if (li) { input.setAttribute('aria-activedescendant', li.id); li.scrollIntoView({ block: 'nearest' }); }
    }
    function open() {
      var res = cfg.items(input.value);
      if (!res) return close();
      opts = res.list;
      var html = res.head ? '<li class="st-ymm__grp st-ymm__head" role="presentation">' + res.head + '</li>' : '', last = null;
      list.className = 'st-ymm__list' + (res.cls ? ' ' + res.cls : '');
      opts.forEach(function (o, i) {
        var g = cfg.groupBy && cfg.groupBy(o);
        if (g && g !== last) { last = g; html += '<li class="st-ymm__grp" role="presentation">' + esc(g) + '</li>'; }
        html += '<li role="option" id="' + list.id + '-o' + i + '" aria-selected="false" data-i="' + i + '">' + cfg.render(o, res) + '</li>';
      });
      if (!opts.length) html += '<li class="st-ymm__empty" role="presentation">' + res.empty + '</li>';
      else if (res.more) html += '<li class="st-ymm__empty" role="presentation">' + res.more + '</li>';
      list.innerHTML = html;
      list.hidden = false; input.setAttribute('aria-expanded', 'true');
      if (opts.length) setActive(0);
    }
    var pick = function (o) { if (cfg.onPick(o) === 'reopen') open(); else close(); };
    input.addEventListener('input', function () { if (input.value.trim() || cfg.openEmpty) open(); else close(); });
    input.addEventListener('focus', function () { if (input.value.trim() || cfg.openEmpty) open(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) open(); else if (opts.length) setActive(Math.min(active + 1, opts.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (opts.length) setActive(Math.max(active - 1, 0)); }
      else if (e.key === 'Enter') {
        if (!list.hidden && active >= 0) { e.preventDefault(); pick(opts[active]); }
        else if (cfg.onEnter) { e.preventDefault(); cfg.onEnter(); }
      }
      else if (e.key === 'Escape') close();
    });
    list.addEventListener('mousedown', function (e) {
      var li = e.target.closest('[role=option]');
      if (li) { e.preventDefault(); pick(opts[+li.dataset.i]); }
      else e.preventDefault();   // clicks on headings/notes keep focus in the box
    });
    input.addEventListener('blur', function () { setTimeout(close, 100); });
    return { open: open, close: close };
  }

  // analytics (snippets/st-analytics: window.stTrack); which page the finder is on
  var track = function (n, d) { if (window.stTrack) window.stTrack(n, d); };
  function section() {
    var p = location.pathname;
    return p === '/' ? 'home_hero' : p === '/pages/car-tint' ? 'car_tint_page' : p.indexOf('/pages/car-tint-make/') === 0 ? 'make_page'
      : p.indexOf('/collections/') === 0 ? 'collection' : p.indexOf('/products/') === 0 ? 'product' : 'other';
  }

  function init(root) {
    var q = root.querySelector('[data-st-q]'), list = document.getElementById(q.getAttribute('aria-controls'));
    var go = root.querySelector('[data-st-go]'), status = root.querySelector('[data-st-status]');
    var preMake = root.dataset.make || '', V = null, qV = null, qY = null;

    function yearPart(text) {                  // the picked name plus a (partial) year before or after it -> the digits
      if (!qV) return null;
      var n = norm(text), name = norm(nameOf(qV));
      if (n.indexOf(name) < 0) return null;
      var rest = n.replace(name, '').trim();
      return /^\d{0,4}$/.test(rest) ? rest : null;
    }
    function complete() { return qV && (qY || !qV.from); }
    function sync(text) {                      // keep the picked state in step with what's in the box
      var rest = yearPart(text);
      if (rest === null) { qV = null; qY = null; }
      else qY = rest.length === 4 && +rest >= qV.from && +rest <= qV.to ? +rest : null;
      go.disabled = !complete();
      status.textContent = qV && !complete() ? 'Now pick the year of your ' + qV.model + '.' : '';
      return rest;
    }
    function finish(v, y) { qV = v; qY = y; q.value = (y ? y + ' ' : '') + nameOf(v); q.scrollLeft = 0; sync(q.value); }
    // "Order this kit again" links (customer accounts, tracker T43): /pages/car-tint?q=2006 Dodge Durango&kit=complete
    // &film=…&front=50&back=50&rear=50. The kit, film and shades ride along to the kit page; the text fills the box.
    var urlP = new URLSearchParams(location.search), carry = new URLSearchParams();
    ['kit', 'film', 'front', 'back', 'rear'].forEach(function (k) { if (urlP.get(k)) carry.set(k, urlP.get(k).slice(0, 40)); });
    function kitUrl(v, y) {
      var p = new URLSearchParams(carry); if (y) p.set('year', y);
      var s = p.toString();
      return '/pages/car-tint-kits/' + v.handle + (s ? '?' + s : '');
    }
    function submit() {
      if (!complete()) return;
      track('finder_go', { vehicle: qV.handle, year: qY || '', section: section() });
      location.href = kitUrl(qV, qY);
    }
    // finder_search / finder_no_match: once the text settles (3+ characters, 1 s without typing), once per distinct text
    var lastQ = '', tmr = null;
    q.addEventListener('input', function () {
      clearTimeout(tmr);
      tmr = setTimeout(function () {
        if (!V || qV) return;                                  // not while choosing a year
        var t = q.value.toLowerCase().replace(/\s+/g, ' ').trim().slice(0, 60);
        if (t.length < 3 || t === lastQ) return;
        lastQ = t;
        var r = search(V, t, preMake);
        track('finder_search', { query: t, results: r.total, has_year: !!r.year });
        if (!r.total || r.skipped.length || r.fixed) track('finder_no_match', { query: t, skipped_word: r.skipped.join(' '), corrected_to: r.fixed || '' });
      }, 1000);
    });

    combobox(q, list, {
      openEmpty: !!preMake,
      items: function (text) {
        if (!V) return { list: [], empty: 'Loading vehicles…' };
        var rest = sync(text);
        if (qV) {                              // year step: the vehicle is chosen, list its years
          if (!qV.from) return null;
          var ys = [];
          for (var y = qV.to; y >= qV.from; y--) {
            if (String(y).indexOf(rest) === 0 || (rest.length === 2 && String(y).slice(2) === rest)) ys.push({ year: y });   // "18" = 2018
          }
          return { list: ys, cls: 'st-ymm__list--years', head: 'Which year is your ' + esc(qV.model) + '?',
                   empty: 'We list ' + esc(qV.model) + ' kits for ' + yrs(qV) + '. For another year, <a href="/pages/contact">ask us</a>.' };
        }
        var r = search(V, text || preMake, preMake);
        return { list: r.hits.map(function (v) { return { v: v, year: r.year }; }), toks: r.toks,
          head: r.fixed && r.hits.length ? 'Showing results for “' + esc((r.year ? r.year + ' ' : '') + r.fixed) + '”:'
              : r.skipped.length && r.hits.length ? 'No match for “' + esc(r.skipped.join(' ')) + '”, so showing the rest:' : '',
          empty: r.year ? 'No ' + r.year + ' match. Check the year, or try just the model.'
                        : 'No match. Try just the model, e.g. “accord”, or <a href="/pages/contact">ask us</a>.',
          more: r.total > r.hits.length ? (r.total - r.hits.length) + ' more: keep typing to narrow it down' : '' };
      },
      render: function (o, r) {
        return o.v
          ? '<span>' + (o.year ? '<mark>' + o.year + '</mark> ' : '') + highlight(nameOf(o.v), r.toks) + '</span><span class="st-ymm__yrs">' + yrs(o.v) + '</span>'
          : '<span>' + o.year + '</span>';
      },
      groupBy: function (o) { return o.v && o.v.make; },
      onPick: function (o) {
        if (!o.v) { track('finder_pick', { vehicle: qV.handle, year: o.year, step: 'year', typed_year: false }); return finish(qV, o.year); }
        track('finder_pick', { vehicle: o.v.handle, year: o.year || '', step: o.year ? 'year' : 'vehicle', typed_year: !!o.year });
        if (!o.v) return finish(qV, o.year);                               // picked a year
        if (o.year) return finish(o.v, o.year);                            // a year was typed with the search
        if (!o.v.from) return finish(o.v, null);                           // no years listed: kit page asks
        if (o.v.from === o.v.to) return finish(o.v, o.v.from);             // only one model year
        qV = o.v; qY = null; q.value = nameOf(o.v) + ' '; sync(q.value);
        return 'reopen';                                                   // ask for the year next
      },
      onEnter: submit
    });
    go.addEventListener('click', submit);
    load(root.dataset.src).then(function (list) {
      V = list;
      var pre = (urlP.get('q') || '').slice(0, 60).trim();
      if (pre && root === document.querySelector('[data-st-ymm]')) {
        var r = search(V, pre.toLowerCase(), preMake);
        // one vehicle that covers the year, matched on every word as typed (no spelling fix, no dropped word): straight
        // to its kit page (a reorder); otherwise show the choices, so "2020 Zzyzx Roadster" never lands on the Audi TT
        if (urlP.get('reorder') && r.total === 1 && !r.fixed && !r.skipped.length && (r.year || !r.hits[0].from)) {
          track('finder_go', { vehicle: r.hits[0].handle, year: r.year || '', section: 'reorder' });
          location.replace(kitUrl(r.hits[0], r.year));
          return;
        }
        q.value = pre; q.focus(); q.dispatchEvent(new Event('input'));
        return;
      }
      if (document.activeElement === q) q.dispatchEvent(new Event('input'));
    });
  }
  document.querySelectorAll('[data-st-ymm]').forEach(init);
})();
